export const API_URL = 'https://api.capusta.space/v1/'
export const API_CABINET = 'https://api.capusta.space/v1/cabinet/'
export const DOCS_URL = 'https://docs.capusta.space/'
export const DOMAIN_TITLE = 'Capusta.maker'
